const defaultExpertBrief =
  'We are working on a project for a client who is looking at {{projectName}}. In connection with this, our client is trying to gain a better understanding of'
const defaultScreeningQuestion =
  '<p>Please let us know about your relevant experience given the project brief above.</p>'
const defaultDisclaimer1 =
  'This engagement does not intend to elicit any confidential, proprietary or non-public information. If any questions appear improper, we encourage you to skip them and let us know.'
const defaultDisclaimer2 =
  'Preliminary screening questions help our clients determine whether your expertise is a good fit for a particular project and are not compensated – you will be paid upon successful completion of a full consultation.'

export { defaultExpertBrief, defaultScreeningQuestion, defaultDisclaimer1, defaultDisclaimer2 }
